module.exports = __webpack_public_path__ + "img/coins_3.064aa38e.png";